import SnackbarAction from '../components/SnackbarAction';

const action = (id: string | number) => <SnackbarAction id={id} />;

export const successVariant: any = {
  variant: 'success'
}

export const infoVariant: any = {
  variant: 'info'
}

export const warningVariant: any = {
  variant: 'warning'
}

export const errorVariant: any = {
  variant: 'error',
  persist: true,
  action
}
